import { api, ApiResponse } from './api'

/**
 * H5 del roadmap (Fase C #7): reconciliación manual de tráfico sin
 * ext_source_id.
 */

export type DistributionMethod = 'spend' | 'clicks'

export interface ChannelSplit {
  leads: number
  revenue: number
  sharePct: number
}

export interface UnassociatedCampaign {
  campaign: string
  sourcePages: string[]
  records: number
  leads: number
  revenue: number
  dateRange: { start: string; end: string }
  flow: string | null
  distributionMethod: DistributionMethod | null
  // null si no hay reconciliación guardada, o si no hay gasto de ninguna
  // plataforma en el rango de fechas con el que repartir.
  split: { google: ChannelSplit; facebook: ChannelSplit; microsoft: ChannelSplit; tiktok: ChannelSplit } | null
}

export const getUnassociatedTraffic = async (): Promise<ApiResponse<{ campaigns: UnassociatedCampaign[]; total: number }>> => {
  const response = await api.get<ApiResponse<{ campaigns: UnassociatedCampaign[]; total: number }>>('/dashboard/unassociated-traffic')
  return response.data
}

export const setTrafficReconciliation = async (
  campaign: string,
  flow: string,
  distributionMethod: DistributionMethod
): Promise<ApiResponse<{ campaign: string; flow: string; distributionMethod: DistributionMethod }>> => {
  const response = await api.put<ApiResponse<{ campaign: string; flow: string; distributionMethod: DistributionMethod }>>(
    '/dashboard/unassociated-traffic',
    { campaign, flow, distributionMethod }
  )
  return response.data
}
